import { useQuery } from '@tanstack/react-query'

import { ApiError } from '@/lib/apiErrors'
import { QUERY_STALE_TIMES } from '@/lib/queryConfig'
import { toI18nKey } from '@/lib/toI18nKey'
import { getOrderAgain } from '@/shared/api/orderAgain'
import { useAuth } from '@/providers/AuthProvider'

export function useOrderAgain(locationRef: string, scheduleRef: string, isDineIn: boolean) {
	const { user, isAuthenticated } = useAuth()
	const userId = user?.id ?? null

	const query = useQuery({
		queryKey: ['order-again', userId, locationRef, scheduleRef, isDineIn],
		queryFn: () => getOrderAgain(locationRef, scheduleRef, 1, isDineIn),
		enabled: isAuthenticated && locationRef !== '' && scheduleRef !== '',
		staleTime: QUERY_STALE_TIMES.SHORT,
	})

	const errorKey =
		query.error != null
			? toI18nKey(
					'olo:order-again',
					query.error instanceof ApiError ? query.error.code : 'UNKNOWN',
				)
			: null

	return { ...query, errorKey }
}
